import { useSyncExternalStore } from "react";

const subscribe = (onChange: () => void) => {
  window.addEventListener("scroll", onChange, { passive: true });
  return () => window.removeEventListener("scroll", onChange);
};

const getSnapshot = () => window.scrollY > 0;

export function useIsScrolled() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
